export default function Section(props) {
  return (
    <section className={props.name}>
      <img src={props.image} alt="section image" />
      <article>
        <h1>{props.header}</h1>
        <p>{props.article}</p>
      </article>
    </section>
  );
}
